import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = a((c, r) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: r,
    ...c,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...e,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3717",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" })
            }
          ),
          /* @__PURE__ */ s.jsx("g", { fill: "currentColor", mask: "url(#mask0_2974_3717)", children: /* @__PURE__ */ s.jsx("path", { d: "M14.2 3.04H8.13c-.41 0-.75.34-.75.75v6.07c0 .41.34.75.75.75h6.07c.41 0 .75-.34.75-.75V3.79c0-.41-.33-.75-.75-.75m-.75 6.07H8.88V4.54h4.57zM3.77 12.45c-.97 0-1.77.79-1.77 1.77s.8 1.77 1.77 1.77 1.77-.8 1.77-1.77-.79-1.77-1.77-1.77m-.27 1.77c0-.15.12-.27.27-.27s.27.12.27.27c.01.3-.54.3-.54 0M5.19 0H2.75C2.34 0 2 .34 2 .75s.34.75.75.75h1.69v9.09c0 .41.34.75.75.75s.75-.34.75-.75V.75c0-.41-.33-.75-.75-.75M14.19 12.05H7.4c-.41 0-.75.34-.75.75s.34.75.75.75h6.78c.41 0 .75-.34.75-.75s-.33-.75-.74-.75" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyTruckIcon";
export {
  t as AgencyTruckIcon,
  t as default
};
//# sourceMappingURL=index.js.map
